import { BaseService } from '../utils/contracts';

export default class ShowingsService extends BaseService {
  constructor() {
    super({ base_url: '/self-tours/api/v1/showing' });
  }

  create(data = {}, options = {}) {
    return this.post('/self-tours', data, options);
  }
}
